/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ArtifactsControllerGetDownloadUrlQueryResponse, ArtifactsControllerGetDownloadUrlPathParams, ArtifactsControllerGetDownloadUrlQueryParams, ArtifactsControllerGetDownloadUrl404 } from "../../models/documentArtifactsController/ArtifactsControllerGetDownloadUrl";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { artifactsControllerGetDownloadUrl } from "../../clients/document-artifactsService/artifactsControllerGetDownloadUrl";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const artifactsControllerGetDownloadUrlQueryKey = (documentId: ArtifactsControllerGetDownloadUrlPathParams["documentId"], renditionId: ArtifactsControllerGetDownloadUrlPathParams["renditionId"], artifactId: ArtifactsControllerGetDownloadUrlPathParams["artifactId"], params: ArtifactsControllerGetDownloadUrlQueryParams = {}) => [{
  url: '/api/v1/documents/:documentId/renditions/:renditionId/artifacts/:artifactId/download-url',
  params: {
    documentId: documentId,
    renditionId: renditionId,
    artifactId: artifactId
  }
}, ...(params ? [params] : [])] as const;
export type ArtifactsControllerGetDownloadUrlQueryKey = ReturnType<typeof artifactsControllerGetDownloadUrlQueryKey>;
export function artifactsControllerGetDownloadUrlQueryOptions(documentId: ArtifactsControllerGetDownloadUrlPathParams["documentId"], renditionId: ArtifactsControllerGetDownloadUrlPathParams["renditionId"], artifactId: ArtifactsControllerGetDownloadUrlPathParams["artifactId"], params?: ArtifactsControllerGetDownloadUrlQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = artifactsControllerGetDownloadUrlQueryKey(documentId, renditionId, artifactId, params);
  return queryOptions<ArtifactsControllerGetDownloadUrlQueryResponse, ResponseErrorConfig<ArtifactsControllerGetDownloadUrl404>, ArtifactsControllerGetDownloadUrlQueryResponse, typeof queryKey>({
    enabled: !!(documentId && renditionId && artifactId),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return artifactsControllerGetDownloadUrl(documentId, renditionId, artifactId, params, config);
    }
  });
}

/**
 * @description Generates a presigned URL for downloading the artifact file
 * @summary Get presigned download URL
 * {@link /api/v1/documents/:documentId/renditions/:renditionId/artifacts/:artifactId/download-url}
 */
export function useArtifactsControllerGetDownloadUrl<TData = ArtifactsControllerGetDownloadUrlQueryResponse, TQueryData = ArtifactsControllerGetDownloadUrlQueryResponse, TQueryKey extends QueryKey = ArtifactsControllerGetDownloadUrlQueryKey>(documentId: ArtifactsControllerGetDownloadUrlPathParams["documentId"], renditionId: ArtifactsControllerGetDownloadUrlPathParams["renditionId"], artifactId: ArtifactsControllerGetDownloadUrlPathParams["artifactId"], params?: ArtifactsControllerGetDownloadUrlQueryParams, options: {
  query?: Partial<QueryObserverOptions<ArtifactsControllerGetDownloadUrlQueryResponse, ResponseErrorConfig<ArtifactsControllerGetDownloadUrl404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? artifactsControllerGetDownloadUrlQueryKey(documentId, renditionId, artifactId, params);
  const query = useQuery({
    ...artifactsControllerGetDownloadUrlQueryOptions(documentId, renditionId, artifactId, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ArtifactsControllerGetDownloadUrl404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}